module.exports = __webpack_public_path__ + "img/logo.d9c06182.png";